import React from "react";

interface PageTitleProps {
    children: React.ReactNode
}

export default function PageTitle({children}: PageTitleProps) {
    return (
        <div className="eo-pageTitle">
            {children}
        </div>
    )
}